// extracted by mini-css-extract-plugin
module.exports = {"list":"DataList-module__list___iJlXf","itemLabel":"DataList-module__itemLabel___1MyBk"};